import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
            热门分类
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            探索你喜欢的类型
          </h2>
          <p className="mt-2 text-sm text-foreground-500">八大分类，海量韩漫等你来发现</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden bg-background-50 hover:bg-background-200/50 transition-all duration-300 p-5 md:p-6 cursor-pointer flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center">
                  <i className={`${cat.icon} text-xl md:text-2xl text-primary-600`}></i>
                </span>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900">
                {cat.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}